export default __webpack_public_path__ + "static/media/groups.df84749f.svg";